<div class="modal-header bg-head py-2">
  <h6 class="modal-title">Study Material : Practice Question </h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCross()"></button>
</div>

<div class="modal-body m-body px-0">
    <div class="px-5 text-danger fw-medium">
    Practice questions are chosen from the list of questions assigned to the course for the topics included in the study unit under which the study
    material is added. If a question does not appear here, it is likely not assigned to the topic.
    To assign questions to a course, go to Question, navigate to the desired topic, and select Assign Question to Course.
  </div>
  <div class="row g-3 px-3 pt-3">
    <div *ngIf=" practiceQuestion && practiceQuestion!.length > 0; else noQuestions" class="row g-3 px-3 pt-3">
    <div class="col-md-6" *ngFor="let question of practiceQuestion; let index = index">
      <div class="row align-items-center g-2">

        <!-- Question Box Column -->
        <div class="col">
          <div class="example-box-question">
            <div
              class="w-100"
              [ngClass]="question.selectedForRelocation ? 'tile-background-selected' : 'tile-background'"
              style="max-width: 100%; height: 100%;"
            >
              <!-- Header -->
              <h4 class="headertext-color-list text-center d-flex align-items-center justify-content-center position-relative">
                {{ question.Question_ID }}

                <!-- Right Section -->
                <div class="position-absolute d-flex gap-2 align-items-center" style="right:20px">
                  <span class="me-2" *ngIf="question.Question_Display_Order">{{ question.Question_Display_Order }}</span>
                  <i
                    class="fa fa-eye pointer-cursor"
                    title="Preview Question"
                    (click)="openQuestionPreview(question)"
                  ></i>
                </div>

                <!-- Left Section -->
                <span class="position-absolute fs-5" style="left:20px" *ngIf="question.Question_Status_Type_Name">
                  {{ question.Question_Status_Type_Name }}
                </span>
              </h4>

              <!-- Question & Answers Body -->
              <div class="row bg-white mx-4 mt-2 q-container" style="max-height: 300px; min-height: 300px; overflow-y: auto;">
                <div
                  class="col-12 mb-2 question-text-area"
                  style="word-wrap: break-word; text-align: left; padding: 10px; border: 1px solid #ddd; border-radius: 4px; background-color: #f8f9fa;"
                >
                  <span class="d-block" [innerHtml]="question.Question_Text"></span>
                </div>

                <!-- Answers -->
                <div class="col-12">
                  <div class="row py-1" *ngFor="let answer of question.AllAnswers">
                    <div class="col-4 col-md-3 text-end pe-2 AnswerChoicelabel">
                      {{ answer.Right_Answer_Ind === 'Y' ? 'Right Answer' : 'Wrong Answer' }}:
                    </div>
                    <div class="col-8 col-md-9 AnswerChoicelabel1">
                      <div class="d-block" [innerHtml]="answer.Answer_Choice_Text"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="px-3 py-2 fw-bold text-white" style="background-color: #2E72B8;">
                Created By: {{ question.Created_By }} ({{ question.Creation_Date | date:'M/d/yy, h:mm a' }})
              </div>
            </div>
          </div>
        </div>

        <!-- Checkbox Column (Right Side) -->
        <div class="col-auto pe-3">
          <input
            style="width: 20px; height: 20px;"
            type="checkbox"
            [(ngModel)]="question.isChecked"
            (change)="onCheckboxChange(question, index)"
          />
        </div>
      </div>
    </div>
    </div>


      <!-- Template for no questions -->
  <ng-template #noQuestions>
    <div class="d-flex justify-content-center align-items-center" style="height: 300px;">
      <p class="text-muted mb-0">No questions available</p>
    </div>
  </ng-template>

  </div>

</div>

<div class="modal-footer">
  <button type="button" class="bl-btn btn btn-sm" (click)="onSave()">Save</button>
  <button type="button" class="btn btn-sm bg-light border" (click)="onCross()">Cancel</button>
</div>

<div class="practice-question-preview-shell" *ngIf="Questionpreviewpopupflag">
  <div class="practice-question-preview-backdrop" (click)="ReturnQuestionpreview()"></div>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header preview-modal-header">
        <h6 class="modal-title fw-semibold mb-0" id="QuestionTemplatetitle">Question Preview</h6>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="ReturnQuestionpreview()"
        ></button>
      </div>

      <div class="modal-body preview-modal-body">
        <app-question-preview
          [previewdetail]="previewdetail"
          [enableActions]="!isQuestionApproved(currentPreviewQuestion)"
          (ReturnQuestionpreview)="ReturnQuestionpreview()"
          (EmitpreviewtoQuestion)="EmitpreviewtoQuestion()"
          (EmitpreviewtoAnswerChoice)="EmitpreviewtoAnswerChoice()"
          (EmitpreviewtoAnswerChoiceNote)="EmitpreviewtoAnswerChoiceNote()"
          (EmitpreviewtoSolutionHint)="EmitpreviewtoSolutionHint()"
        ></app-question-preview>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" style="z-index:1090" *ngIf="EditQuestionBodyPopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Question</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="EditQuestionBodyclose()" style="margin: 0.35rem 0.75rem 0.35rem 0;"></button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-question-body-add-edit
          [selectedQuestionList]="null"
          [subjectById]="subjectById"
          [selectedQuestionById]="selectedQuestionById"
          [EditQuestionBodyPopup]="EditQuestionBodyPopup"
          (REdirecttoRightAnswer)="REdirecttoRightAnswer($event)"
          (EditQuestionBodyclose)="EditQuestionBodyclose()"
          (Returnpreview)="Returnpreview()"
          (REdirectPreview)="REdirectPreview($event)"
          (Questionrefreshpreview)="Questionrefreshpreview($event)"
        ></app-question-body-add-edit>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" style="z-index:1090" *ngIf="EditAnswerChoicePopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Answer</h6>
        <button type="button" class="close" (click)="EditAnswerchoiceclose()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-answer-choice-add-edit
          [subjectById]="null"
          [Screenname]="Screenname"
          [Answerflag]="Answerflag"
          [selectedQuestionById]="selectedQuestionById"
          (EditAnswerChoiceNoteBody)="EditAnswerChoiceNoteBody($event)"
          (EditSolutionHint1)="EditSolutionHint1($event)"
          (EditAnswerchoiceclose)="EditAnswerchoiceclose()"
          (Returnpreview)="Returnpreview()"
          (returnfromanswer)="returnfromanswer($event)"
          (AnswerRedirectPreview)="AnswerRedirectPreview($event)"
          (RefreshPreviewAnswer)="RefreshPreviewAnswer($event)"
        ></app-answer-choice-add-edit>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" style="z-index:1090" *ngIf="AnswerChoiceNotePopup1">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Answer Note</h6>
        <button type="button" class="close" (click)="EditAnswerchoiceNoteclose()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-answer-choice-note
          [AnswerChoiceNotePopup1]="AnswerChoiceNotePopup1"
          [selectedQuestionById]="selectedQuestionById"
          (REdirecttoRightAnswerfromnote)="REdirecttoRightAnswerfromnote($event)"
          (EditAnswerchoiceNoteclose)="EditAnswerchoiceNoteclose()"
          (Returnpreview)="Returnpreview()"
        ></app-answer-choice-note>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" style="z-index:1090" *ngIf="SolutionHintPopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Add/Edit Solution Hint</h6>
        <button type="button" class="close" (click)="EditAnswerchoiceNoteclose11()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-answer-choice-solution-hint
          [selectedQuestionById]="selectedQuestionById"
          (REdirecttoRightAnswerfromnote)="REdirecttoRightAnswerfromnote($event)"
          (EditAnswerchoiceNoteclose11)="EditAnswerchoiceNoteclose11()"
          (Returnpreview)="Returnpreview()"
        ></app-answer-choice-solution-hint>
      </div>
    </div>
  </div>
</div>
